import React from 'react';
import { Link } from 'react-router-dom';
import MessagesTable from './messagesTable';
import MessagesFilter from './messagesFilter';
import Pagination2 from '../../components/Pagination2';
import * as messagesActions from '../../redux/messages/actions';
import submitForm from '../../utils/submitForm';
import { connect } from 'react-redux';
import Spin from '../../components/loading';
import ShowForPermission from '../../components/ShowForPermission';
import ENUMS from '../../enums';
import AlertAndConfirmation from '../../utils/AlertAndConfirmation';

class Messages extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      sortType: 'asc',
      sortBy: 'createdAt',
      errorText: locales('errors.default'),
      errorFlag: false,
      itemsPerPage: 10
    };
  }
  componentDidMount() {
    this.sortTable(this.state.sortBy);
  }

  handleAlert = () => {
    AlertAndConfirmation({ text: this.state.errorText, type: 'error' });
    this.setState({ errorFlag: false });
  };

  buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      console.log('pageNumber is: ', pageNumber);
      console.log('pageSize is: ', pageSize);
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&${this.state.query || 'sort=createdAt-desc'}`;
      return query;
    }
  };

  onPageChanged = data => {
    const { currentPage, totalPages, pageLimit } = data;

    console.log('pagination data: ', data);

    this.setState({ currentPage: currentPage }, () => {
      const query = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
      this.props.fetchAllMessages(query);
    });
  };
  filterAndSort = () => {
    let { filter, sort } = this.state;
    let query;
    if (sort && filter) query = `${filter}&${sort}`;
    else if (filter) query = `${filter}`;
    else if (sort) query = `${sort}`;
    this.setState({ query, currentPage: 1 }, () => {
      let searchQuery = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
      console.log('filter===>>', searchQuery);
      this.props.fetchAllMessages(searchQuery);
    });
  };
  sortTable = query => {
    this.setState({ sortType: this.state.sortType == 'asc' ? 'desc' : 'asc' }, () => {
      query = `${query}-${this.state.sortType}`;
      this.setState({ sort: `sort=${query}` }, () => this.filterAndSort());
    });
  };

  applyFilters = event => {
    const queryString = submitForm(event, this.state.selectedRegions, this.state.selectedAmenities);
    this.setState({ filter: queryString }, () => this.filterAndSort());
  };
  render() {
    let { loading, message, failed, error } = this.props;
    let { totalRecords } = this.props.messages;
    let { currentPage, itemsPerPage, sortType } = this.state;
    return (
      <>
        {this.state.errorFlag && this.handleAlert()}
        <section className="p-1 col-12">
          <div className="col-12 d-flex justify-content-between align-items-center">
            <h3 className="text-right text-muted py-4">{locales('titles.messagesManagement')}</h3>
            <ShowForPermission permission={ENUMS.PERMISSIONS.values.SEND_NEW_MESSAGE}>
              <Link to="/messages/send">
                <button className="btn btn-success w-5">
                  <i className="fa fa-plus" />
                  {locales('titles.sendNewMessage')}
                </button>
              </Link>
            </ShowForPermission>
          </div>
          {/* <div className='col-12 d-flex justify-content-center align-items-center h-100'> */}
          <Spin spinning={loading}>
            <article>
              <main className="panel panel-default">
                {error ? (
                  <div className="alert alert-danger">{locales('messages.server.error')}</div>
                ) : (
                  <>
                    {failed && <div className="alert alert-danger">{message}</div>}
                    <div className="panel-heading">
                      <i className="fas fa-list-alt px-1" />
                      {locales('titles.messagesList')}
                    </div>
                    <div className="panel-body">
                      <MessagesFilter applyFilters={this.applyFilters} filterAndSort={this.filterAndSort} />
                      <MessagesTable
                        pageNumber={currentPage}
                        pageSize={itemsPerPage}
                        sortType={sortType}
                        sortTable={this.sortTable}
                      />
                      <footer className="col-12 d-flex justify-content-center py-2">
                        <div className="pagination-container">
                          <Pagination2
                            totalRecords={totalRecords || 0}
                            pageLimit={itemsPerPage}
                            pageNeighbours={2}
                            onPageChanged={this.onPageChanged}
                            currentPage={this.state.currentPage}
                          />
                        </div>
                      </footer>
                    </div>
                  </>
                )}
              </main>
            </article>
          </Spin>
        </section>
      </>
    );
  }
}
const mapStateToProps = state => {
  return {
    messagesList: state.messagesReducer.messagesList,
    messages: state.messagesReducer.messages || {},
    loading: state.messagesReducer.loading,
    message: state.messagesReducer.message,
    failed: state.messagesReducer.failed,
    error: state.messagesReducer.error
  };
};
const mapDispatchToProps = dispatch => {
  return {
    fetchAllMessages: query => dispatch(messagesActions.fetchAllMessages(query))
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Messages);
